/**
 * Apollo Client for Web
 *
 * DEPRECATED: Use unified-client.ts instead
 *
 * This file is kept for backward compatibility.
 * New code should use:
 * - setUnifiedClient() to set the client
 * - getUnifiedClient() to get the client
 *
 * @see unified-client.ts
 */

import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import {
    getUnifiedClient,
    setUnifiedClient,
    isUnifiedClientInitialized,
    initClient as unifiedInitClient,
} from './unified-client';

/**
 * Init client configuration
 */
export interface InitClientConfig {
    uri?: string;
    uploadClient?: boolean;
}

/**
 * Init client result
 */
export interface InitClientResult {
    client: ApolloClient<NormalizedCacheObject>;
}

/**
 * Initialize Apollo Client
 *
 * @deprecated Use setUnifiedClient() and getUnifiedClient() instead
 */
export const initClient = async (config?: InitClientConfig): Promise<InitClientResult> => {
    return unifiedInitClient(config);
};

/**
 * Get current Apollo Client instance
 *
 * @deprecated Use getUnifiedClient() instead
 */
export const getClient = (): ApolloClient<NormalizedCacheObject> | null => {
    if (isUnifiedClientInitialized()) {
        return getUnifiedClient();
    }
    return null;
};

/**
 * Set Apollo Client (for external initialization)
 *
 * @deprecated Use setUnifiedClient() instead
 */
export const setClient = (client: ApolloClient<NormalizedCacheObject>): void => {
    setUnifiedClient(client);
};

/**
 * Alias for compatibility
 * @deprecated Use getUnifiedClient() instead
 */
export const client = isUnifiedClientInitialized() ? getUnifiedClient() : null;
